// extracted by mini-css-extract-plugin
export var active = "_73-a";
export var activeIndicator = "_73-9";
export var disabled = "_73-b";
export var fullWidth = "_73-2";
export var lg = "_73-7";
export var md = "_73-6";
export var redoButtonTabGroup = "_73-0";
export var sm = "_73-5";
export var tabButton = "_73-4";
export var tabButtonsContainer = "_73-1";
export var themeDestructive = "_73-d";
export var themeNormal = "_73-c";
export var themeSuccess = "_73-e";
export var xl = "_73-8";
export var xs = "_73-3";